<app-common-subproducts-hero
  [heroData]="heroHeader"
></app-common-subproducts-hero>
<app-common-subproducts-alternate-blocks
  [featureData]="featureData1"
></app-common-subproducts-alternate-blocks>
<app-common-subproducts-how-it-works
  [howItWorksData]="howItWorksData"
  [columns]="5"
></app-common-subproducts-how-it-works>
<app-common-faq
  [faqData]="faqData"
  [customClass]="'treasury-faq'"
></app-common-faq>
<app-common-subproducts-discover-difference
  [differenceData]="differenceData"
  isInside="true"
></app-common-subproducts-discover-difference>
<app-common-subproducts-pricing
  [pricingData]="pricingData"
></app-common-subproducts-pricing>
<app-common-subproducts-whitepaper
  [whitePaperData]="whitePaperData"
></app-common-subproducts-whitepaper>
<app-common-getstarted
  [getStartedData]="getStartedData"
></app-common-getstarted>
